import styled from '@emotion/styled';

export const DateFormatWrapper = styled.span`
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-thin);
  margin-left: auto;
`;

export const NotificationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  padding-right: var(--gutter-small);
  padding-left: var(--gutter-little);
  border-bottom: var(--regular-border-width) solid var(--color-box-border);
`;

export const NotificationContent = styled.div`
  padding: var(--gutter-small) var(--gutter) var(--gutter);
  border-bottom: var(--regular-border-width) solid var(--color-box-border);
`;

export const DelayHeading = styled.div`
  padding: var(--gutter-small) var(--gutter) 0;
`;

export const ButtonWrapper = styled.div`
  margin-top: var(--gutter);
  display: flex;
  justify-content: flex-end;
`;

export const DelayOptions = styled.div`
  display: flex;
  gap: var(--form-gutter);
  padding: var(--gutter-small) var(--gutter) var(--gutter);
`;
